import React, { useEffect } from 'react';

import { Controller, useForm } from 'react-hook-form';

import { Button, Input, InputGroup, PhoneNumberPicker } from 'components/FormComponents';

export const RefereeDetails = ({ referee, company, onSubmit = () => {} }) => {
  const { reset, register, handleSubmit, control } = useForm({
    defaultValues: {
      id: referee.id,
      first_name: referee.first_name,
      last_name: referee.last_name,
      email: referee.email,
      contact_number: referee.contact_number,
      form_name: referee.form_name,
    },
  });

  useEffect(
    () =>
      reset({
        id: referee.id,
        first_name: referee.first_name,
        last_name: referee.last_name,
        email: referee.email,
        contact_number: referee.contact_number,
        form_name: referee.form_name,
      }),
    [referee],
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8">
      <div className="inline">
        <InputGroup title="First name">
          <Input
            name="first_name"
            register={register}
            validators={{ required: true }}
            placeholder="John"
          />
        </InputGroup>
        <InputGroup title="Last name">
          <Input
            name="last_name"
            register={register}
            validators={{ required: true }}
            placeholder="Doe"
          />
        </InputGroup>
      </div>
      <InputGroup title="Email">
        <Input
          name="email"
          register={register}
          validators={{ required: true }}
          placeholder="john@checkmate.com"
        />
      </InputGroup>
      <InputGroup title="Form">
        <Input name="form_name" register={register} disabled={true} />
      </InputGroup>
      <InputGroup title="Contact Number">
        <Controller
          control={control}
          name="contact_number"
          render={({ field: { onChange, value } }) => (
            <PhoneNumberPicker
              value={value}
              onChange={onChange}
              defaultCountry={company?.country}
            />
          )}
        />
      </InputGroup>
      <Button className="w-full" submit>
        Update
      </Button>
    </form>
  );
};
